












































import { createComponent, ref, computed } from "@vue/composition-api";
import { useRouting } from "@dcc/compositions/useRouting";
import { BaseLink, BasePrimaryButton } from "@web-components";
import DrinkingTabs from "@dcc/components/DrinkingTabs.vue";
import { findGetters } from "@dcc/store/drinking/getters";
import { getActions } from "@dcc/store/drinking/actions";
import { setTabsEnabled, setNextDisabled } from "@dcc/common/drinkingDayUtils";
// eslint-disable-next-line
import { UpdateDrink } from "@dcc/views/types/updateDrink";

import { MIN_DRINKS, MAX_DRINKS } from "@dcc/constants/drinkConstants";
import { daysOfWeekText } from "@dcc/types/dayOfWeek";
import { useDictionary } from "@dcc/views/compositions/useDictionary";

export default createComponent({
  components: {
    BaseLink,
    DrinkingTabs,
    BasePrimaryButton
  },
  setup(props: {}, context) {
    const { handleNext, handlePrev } = useRouting(context);
    const dictionary = useDictionary();
    const currentTab = ref(0);

    const { getTotalDrinksOnWeekday } = findGetters(context.root.$store);
    const drinksPerWeekday = getTotalDrinksOnWeekday();
    const { updateWeekdayDrinkQuantity } = getActions(context.root.$store);

    const nextIsDisabled = computed(() =>
      setNextDisabled(drinksPerWeekday.value, currentTab.value)
    );

    const tabsEnabled = computed(() =>
      setTabsEnabled(drinksPerWeekday.value, currentTab.value)
    );

    const handleNextClicked = () => {
      if (currentTab.value < drinksPerWeekday.value.length - 1) {
        currentTab.value++;
      } else {
        handleNext();
      }
    };

    const handleBack = () => {
      if (currentTab.value > 0) {
        currentTab.value--;
      } else {
        handlePrev();
      }
    };

    const updateDrink = ({ day, drink, amount }: UpdateDrink) => {
      updateWeekdayDrinkQuantity({
        day,
        drink,
        amount: Number(amount)
      });
    };
    return {
      currentTab,
      daysOfWeekText,
      drinksPerWeekday,
      MIN_DRINKS,
      MAX_DRINKS,
      nextIsDisabled,
      tabsEnabled,
      updateDrink,
      handleBack,
      handleNextClicked,
      ...dictionary
    };
  }
});
